<div class="input-container">
    <label for="uploads_rackspace_username" trans>Rackspace Username</label>
    <input type="text" id="uploads_rackspace_username" name="uploads_rackspace_username" [(ngModel)]="state.server['uploads_rackspace_username']" required>
</div>

<div class="input-container">
    <label for="uploads_rackspace_key" trans>Rackspace Key</label>
    <input type="text" id="uploads_rackspace_key" name="uploads_rackspace_key" [(ngModel)]="state.server['uploads_rackspace_key']" required>
</div>

<div class="input-container">
    <label for="uploads_rackspace_region" trans>Rackspace Region</label>
    <input type="text" id="uploads_rackspace_region" name="uploads_rackspace_region" [(ngModel)]="state.server['uploads_rackspace_region']" required>
</div>

<div class="input-container">
    <label for="uploads_rackspace_container" trans>Rackspace Container</label>
    <input type="text" id="uploads_rackspace_container" name="uploads_rackspace_container" [(ngModel)]="state.server['uploads_rackspace_container']" required>
</div>